export default __webpack_public_path__ + "static/lsa-nextImage-693af1e24c37cdca8f2240a16ac1c51f.jpg";